import { isSellerOrSalesUserRole } from '@/enums/user-role.enum'
import { isOrdersType, isSubscriptionType } from './payment-links-types.enum'

const INFOS_TAB = {
  slotName: 'infos',
  active: true,
  enabled: true
}

const ORDERS_TAB = {
  slotName: 'orders',
  active: false,
  enabled: true,
  shouldIsVisibled: (paymentsLinksTypes, userRoleType) =>
    isOrdersType(paymentsLinksTypes) && !isSellerOrSalesUserRole(userRoleType)
}

const SUBSCRIPTIONS_TAB = {
  slotName: 'subscriptions',
  active: false,
  enabled: false,
  shouldIsVisibled: (paymentsLinksTypes, userRoleType) =>
    isSubscriptionType(paymentsLinksTypes) &&
    !isSellerOrSalesUserRole(userRoleType)
}

const TABS = [INFOS_TAB, ORDERS_TAB, SUBSCRIPTIONS_TAB]

export { ORDERS_TAB, SUBSCRIPTIONS_TAB, TABS }
